import styled from 'styled-components';

export const ContactListWrap = styled.div`
    display: block;
    width: 100%;
    overflow: auto;
`;
